exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-box .title[data-v-5f2690f5]{cursor:pointer}", ""]);

// exports
